module.exports = __webpack_public_path__ + "static/media/Wind.eb0fc13e.ogg";